import getters from '@/store/modules/classes/getters';
import mutations from '@/store/modules/classes/mutations';
import actions from '@/store/modules/classes/actions';

export const state = {
  classInfo: {
    classNo: '',
    studentNo: '',
    studentName: '',
    className: '',
    teacherName: '',
    filePath: '',
    studentOrder: [],
    orderDetail: []
  },

  orderInfo: {
    classNo: '',
    studentOrderNo: '',
    className: '',
    orderName: '',
    classContent: '',
    file: '',
    filePath: '',
    fileName: '',
    score: []
  }
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
